import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  label: {
    id: 'CategorySelector.label',
    defaultMessage: 'Select the event you are hosting',
  },
  wedding: {
    id: 'CategorySelector.wedding',
    defaultMessage: 'Wedding',
  },
  babyShower: {
    id: 'CategorySelector.babyShower',
    defaultMessage: 'Baby Shower',
  },
  birthday: {
    id: 'CategorySelector.birthday',
    defaultMessage: 'Birthday',
  },
  funeral: {
    id: 'CategorySelector.funeral',
    defaultMessage: 'Funeral',
  },
  other: {
    id: 'CategorySelector.other',
    defaultMessage: 'Other',
  },
})
